import React from 'react';
import { makeStyles } from 'src/makeStyles';
import CircularProgress from '@mui/material/CircularProgress';

const useStyles = makeStyles()({
  root: {
    display: 'flex',
    justifyContent: 'center',
  },
});

const AppCircularProgress = ({ className, size = 40 }) => {
  const { classes } = useStyles();

  return (
    <div className={classes.root}>
      <CircularProgress className={className} size={size} />
    </div>
  );
};

export default AppCircularProgress;
